var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media_con"},[_c('video',{attrs:{"src":_vm.video_url4,"controls":"","poster":require("../../static/other/jianjie.jpg"),"width":"582"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }